import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { ServicePlanItemPricingPolicy } from 'src/features/servicePlanPricingPolicies/utils/types';
import { PatchServicePlanPricingPolicyFormSchemaValues } from 'src/features/servicePlanPricingPolicies/utils/formSchema';

const RESOURCE =
    '/subscriptions/service-plan-item/:servicePlanItemId/service-plan-item-pricing-policy/:pricingPolicyId/';

type MutationFnType = typeof mutationFn;

interface DTO extends PatchServicePlanPricingPolicyFormSchemaValues {
    servicePlanItemId: string;
    pricingPolicyId: string;
}

const mutationFn = ({ pricingPolicyId, servicePlanItemId, ...data }: DTO): Promise<ServicePlanItemPricingPolicy> => {
    return axios.patch(formatResourcePath(RESOURCE, { servicePlanItemId, pricingPolicyId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as usePatchServicePlanPricingPolicy };
